import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';

import { MaterialModule } from '../../modules/material/material.module';
import { SmsTemplateModalComponent } from './sms-template-modal.component';
import { ModalTitleComponent } from '../../global/modal-title/modal-title.component';
import { SmsTemplateGroupComponent } from "../../../pages/facility/sms-template-group/sms-template-group.component";


@NgModule({
  declarations: [
    SmsTemplateModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslationModule,
    ModalTitleComponent,
    SmsTemplateGroupComponent
],
  exports: [
    SmsTemplateModalComponent,
  ]

})
export class SmsTemplateModalModule { }
